import React from 'react'
import './aboutfoundation.scss'

const AboutFoundation = () => {
    return (
        <>
            <section className='foundation_bg'>
                <div className="custom-container foundation_main">

                    {window.innerWidth > 991 ? (
                        <img
                            src="/assets/about/foundation.png"
                            alt="foundationimg"
                            className="foundation_img"
                        />
                    ) : (
                        <img
                            src="/assets/about/foundation-mb.png"
                            alt="foundationimg"
                            className="foundation_img"
                        />
                    )}

                    <div className="foundation_right">
                        <h3 className='about_common_heading'>The Foundation</h3>
                        <p className='about_p'>
                            The Rain Foundation is a non-profit foundation established in Panama to support the long-term growth and development of the Rain Protocol ecosystem. Its purpose is to steward the protocol and its assets, promote the adoption of decentralized prediction markets, and ensure that resources are used to strengthen and expand the network for the benefit of the broader community.
                        </p>
                    </div>

                </div>
                <div className="foundation_shadow"></div>
            </section>
        </>
    )
}

export default AboutFoundation
